import { Capacitor } from "@capacitor/core";

/**
 * 「앱 종료」 — 네이티브(안드로이드) 앱에서만 뜬다. 웹(PWA)은 브라우저 탭을
 * 닫으면 되므로 항목 자체를 숨긴다.
 *
 * 현장 모니터 보드(키오스크 런처가 HOME)에서는 gasM 을 종료하면 런처 화면이
 * 되고, 런처는 몇 초 카운트다운 뒤 gasM 을 다시 띄운다 — 그 사이 「자동 시작
 * 멈춤」을 누르면 보드에 머무를 수 있다(안드로이드 설정 진입 등).
 */
export const isNativeApp = (): boolean => Capacitor.isNativePlatform();

/** 앱 프로세스 종료. Android 만 실제로 종료된다(iOS 는 exitApp 미지원 → no-op). */
export async function exitApp(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { App } = await import("@capacitor/app");
    await App.exitApp();
  } catch {
    /* 플러그인 없음 — 조용히 무시 */
  }
}
